import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Chip, IconButton, Toolbar, styled } from "@mui/material";
import AccountMenu from '../../../components/Layout/AccountMenu';
import ButtonToggleTheme from "../../../components/Layout/ButtonToggleTheme";
import { useAppSelector } from "../../../redux/store";
import { sidebarWidth } from './DSidebar';

const DashboardNavbarRoot = styled(AppBar)(({ theme }) => ({
    boxShadow: 'none',
}));


const DNavbar = ({ onSidebarOpen, navbarHeight }: { onSidebarOpen: () => void, navbarHeight: number }) => {
    const user = useAppSelector(state => state.userState.user);


    return (<> <DashboardNavbarRoot
        sx={{
            left: {
                lg: sidebarWidth
            },
            width: {
                lg: `calc(100% - ${sidebarWidth}px)`
            },
            displayPrint: 'none',
         }}
    >

        <Toolbar
            disableGutters
            sx={{
                minHeight: 64,
                left: 0,
                px: 2
            }}
        >

            <IconButton
                title="AbrirNavbar"
                onClick={onSidebarOpen}
                sx={{
                    display: {
                        xs: 'inline-flex',
                        lg: 'none'
                    }
                }}
            >
                <MenuIcon fontSize="small" />
            </IconButton>
            <Chip label={user?.role} sx={{ textTransform: 'capitalize' }} />

            <ButtonToggleTheme sx={{ justifyContent: 'flex-end' }} />

            <AccountMenu user={user} />
        </Toolbar>




    </DashboardNavbarRoot></>);
}

export default DNavbar;